import { activateLocaleMessages } from "../i18n/effects.js";
import "../i18n/index.js";
import "@bitcart/core/i18n";
import { getPageDocumentMetadata } from "@bitcart/core/metadata";
//#region src/lifecycle/before-render.ts
const createOnBeforeRender = ({ envTag, getStaticDocumentMetadata, loadLocale, posixLocaleIdMap, productionBaseUrl, supportedLocaleIds }) => {
	return async function onBeforeRender(pageContext) {
		const { headers, localeId } = pageContext;
		const localeMessages = await loadLocale(localeId);
		activateLocaleMessages(localeId, localeMessages);
		const baseUrl = typeof headers?.host === "string" ? `${envTag !== "production" ? headers["x-forwarded-proto"] ?? "http" : "https"}://${headers.host}` : productionBaseUrl;
		return { pageContext: {
			metadata: getPageDocumentMetadata({
				baseUrl,
				localeId,
				posixLocaleIdMap,
				routePath: pageContext.urlOriginal,
				staticParams: getStaticDocumentMetadata(),
				supportedLocaleIds
			}),
			messages: localeMessages
		} };
	};
};
//#endregion
export { createOnBeforeRender };

//# sourceMappingURL=before-render.js.map